<ph-dialog [open]="open"
           size="md"
           icon="shield-check"
           heading="Save your recovery codes"
           description="Each code signs you in once if you lose access to your authenticator app or phone."
           no-close>
    <app-recovery-codes-panel *ngIf="open"
                              [codes]="codes ?? []"
                              (acknowledgedChange)="acknowledged = $event"></app-recovery-codes-panel>

    <ph-actions slot="footer">
        <ph-button e2eId="recovery-codes-done"
                   [disabled]="!acknowledged"
                   (click)="done()">Done</ph-button>
    </ph-actions>
</ph-dialog>
